module.exports = __webpack_public_path__ + "static/media/SPOTIFY.fc0a319a.svg";